export default __webpack_public_path__ + "static/media/butt.d6abc48a.jpg";